import React, { useRef, useEffect, useState } from 'react';
import { Editor } from '@toast-ui/react-editor';
import '@toast-ui/editor/dist/toastui-editor.css';
import styles from './TuiEditor.module.css';

export default function TuiEditor({ 
  onSubmit, 
  isSubmitting = false, 
  initialContent = '', 
  initialTitle = '',
  submitButtonText = '등록하기' 
}) {
  const editorRef = useRef(null);
  const [title, setTitle] = useState(initialTitle);
  
  useEffect(() => {
    if (editorRef.current && initialContent && initialContent.trim() !== '') {
      const editorInstance = editorRef.current.getInstance();
      editorInstance.setHTML(initialContent);
    }
  }, [initialContent]);

  useEffect(() => {
    if (initialTitle) {
      setTitle(initialTitle);
    }
  }, [initialTitle]);

  async function handleSubmit() {
    if (!editorRef.current) return;
    
    if (!title.trim()) {
      alert('제목을 입력해주세요.');
      return;
    }
    
    const editorInstance = editorRef.current.getInstance();
    const content = editorInstance.getHTML();
    
    if (!content || content.trim() === '<p><br></p>') {
      alert('내용을 입력해주세요.');
      return;
    }

    try {
      // 부모 컴포넌트의 onSubmit 함수 호출
      const result = await onSubmit(content, title); // 제목도 함께 전달
      
      if (result && !initialContent) {
        // 신규 생성인 경우에만 에디터 초기화
        editorInstance.reset();
        setTitle(''); // 제목도 초기화
      }
    } catch (error) {
      console.error('제출 오류:', error);
      alert('제출 중 오류가 발생했습니다.');
    }
  }
  
  return (
    <div className={styles.editorContainer}>
      <div className={styles.titleInput}>
        <input
          type="text"
          placeholder="제목을 입력해주세요"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          className={styles.titleField}
        />
      </div>
      <div className={styles.editorWrapper}>
        <Editor
          ref={editorRef}
          placeholder="내용을 입력해주세요."
          previewStyle="vertical"
          height="700px"
          initialEditType="wysiwyg"
          toolbarItems={[
            ['heading', 'bold', 'italic', 'strike'],
            ['hr', 'quote'],
            ['ul', 'ol', 'task', 'indent', 'outdent'],
            ['table', 'image', 'link'],
            ['code', 'codeblock']
          ]}
        />
      </div>
      <div className={styles.buttonContainer}>
        <button 
          onClick={handleSubmit} 
          className={styles.submitButton}
          disabled={isSubmitting}
        >
          {isSubmitting ? '처리 중...' : submitButtonText}
        </button>
      </div>
    </div>
  );
}